import React from "react";
import { formatCurrency } from "../../utils/dashboardUtils";

const FinancialSection = ({ insights }) => {
  return (
    <div className="panel-grid panel-grid-half">
      <div className="dashboard-panel">
        <h2>Gender Distribution</h2>
        {insights.genders.length === 0 ? (
          <div className="empty-panel">No gender data available</div>
        ) : (
          <div className="metric-list">
            {insights.genders.map((item) => {
              const width = Math.round(
                (item.count / Math.max(insights.totalVisits, 1)) * 100,
              );
              return (
                <div key={item.name}>
                  <div className="metric-row">
                    <span className="metric-row-name">{item.name}</span>
                    <span className="metric-row-value">{item.count}</span>
                  </div>
                  <div className="metric-track">
                    <div className="metric-fill" style={{ width: `${width}%` }} />
                  </div>
                </div>
              );
            })}
          </div>
        )}
      </div>

      <div className="dashboard-panel">
        <h2>Financial Snapshot</h2>
        <div className="metric-list">
          <div className="metric-row">
            <span className="metric-row-name">Average Bill</span>
            <span className="metric-row-value">
              {formatCurrency(insights.averageBill)}
            </span>
          </div>
          <div className="metric-row">
            <span className="metric-row-name">Coupon Claimed</span>
            <span className="metric-row-value">{insights.couponClaimed}</span>
          </div>
          <div className="metric-row">
            <span className="metric-row-name">Collected</span>
            <span className="metric-row-value">
              {formatCurrency(insights.collectedAmount)}
            </span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default FinancialSection;
